import MenuIcon from '@mui/icons-material/Menu';
import { AppBar as MuiAppBar, Box, IconButton, Toolbar, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import CarrinhoPedido from '../../Pages/Pedido/CarrinhoPedido';
import { COR_PRINCIPAL_DEFAULT } from '../../constants';

type Props = {
  setOpen: (x: boolean) => void;
};

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  height: 64,
  justifyContent: 'center',
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  })
}));

const Header: React.FC<Props> = ({ setOpen }) => {
  const [sessao] = useSessao();
  const corPrincipal = sessao?.empresa?.corPrincipal || COR_PRINCIPAL_DEFAULT;

  return (
    <AppBar
      position="relative"
      elevation={2}
      sx={{
        backgroundColor: corPrincipal
      }}
    >
      <Toolbar sx={{ px: 2 }}>
        <IconButton edge="start" color="inherit" onClick={() => setOpen(true)}>
          <MenuIcon />
        </IconButton>

        <Box
          sx={{
            flex: 1,
            textAlign: 'center'
          }}
        >
          <Typography
            variant="h6"
            noWrap
            sx={{
              fontWeight: 600,
              letterSpacing: 0.5
            }}
          >
            {sessao.empresa?.sigla}
          </Typography>
        </Box>

        {sessao?.empresa?.clientePodeFazerPedido && (
          <Box>
            <CarrinhoPedido />
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
